export default __webpack_public_path__ + "static/media/zalando.4c5ce048.svg";